var WINDOW_KEY = 'commonQueue';

var push = function push(data) {
  window[WINDOW_KEY] = window[WINDOW_KEY] || [];
  window[WINDOW_KEY].push(data);
};

var wrap = function wrap(base) {
  return function (data) {
    push(Object.assign({}, base, {}, data));
  };
};

var toast = wrap({
  name: 'toast'
});
var trackjs = wrap({
  name: 'trackjs'
});
var broadcast = wrap({
  name: 'broadcast'
});

export default push;
export { broadcast, toast, trackjs };
//# sourceMappingURL=client.es.js.map
